import { inject } from "@angular/core";
import { Router, Routes } from "@angular/router";
import { SessionService } from "@kno2/core/session";

export const routes: Routes = [
    {
        path: "account/dashboard",
        loadComponent: () => import("./dashboard/dashboard.component").then((c) => c.DashboardComponent),
        canActivate: [
            () => {
                const sessionService = inject(SessionService);
                const router = inject(Router);

                const canActivate = sessionService.userInRole(["Administrator"]);

                if (canActivate) return true;

                return router.parseUrl("/intake");
            }
        ]
    },
    {
        path: "account/profile/email",
        loadComponent: () => import("./profile/profile.component").then((c) => c.ProfileComponent),
        data: { currentTab: "emailNotifications" }
    },
    {
        path: "account/profile",
        pathMatch: "full",
        loadComponent: () => import("./profile/profile.component").then((c) => c.ProfileComponent)
    },
    {
        path: "account/notifications",
        loadComponent: () => import("./notifications/notifications.component").then((c) => c.NotificationsComponent)
    }
];
